import styled from "styled-components";

export const Br = styled.div`
  height: ${(props) => props.height || "30px;"};
  width: 100%;
`;

